import { createContext } from "react";
import { NativeBridge } from "@swiggy-private/native-bridge";
import type { NextRouter } from "next/router";

interface ScrolledStateContext {
    sdk?: NativeBridge;
    router?: NextRouter;
    isApp?: boolean;
}

const initialValue: ScrolledStateContext = {};

export default createContext(initialValue);
